import { calendarRange, isCalendar } from './datapicker'
// import './datapicker.js'

document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.input-field__input')
  const filterForm = document.querySelector('[data-layout-manager-form]')
  const resetButton = document.querySelector('[data-reset-button]')
  const selects = document.querySelectorAll('[data-select]')
  const dropdowns = document.querySelectorAll('[data-field-dropdown]')
  const dropdownLists = document.querySelectorAll('[data-dropdown-content]')

  let docSelectArr = []
  let calendar
  let search

  inputs &&
    inputs.forEach((input) => {
      if (input.name === 'search') {
        search = input
      }

      if (input.title === 'chevron-down') {
        docSelectArr.push(input)
      }

      if (input.name === 'date') {
        calendar = input
      }
    })

  if (calendar) calendar.readOnly = true

  calendar &&
    calendar.addEventListener('click', (event) => {
      const clearCalendar = (event) => {
        if (event.key === 'Backspace') {
          calendar.value = ''
          calendarRange.clear()
        }
      }

      if (event.target.value !== '')
        calendar.addEventListener('keydown', clearCalendar)
      if (isCalendar) {
        calendar.removeEventListener('keydown', clearCalendar)
        calendarRange.hide()
      }
    })

  const addListener = (arr, select, docSelect, dropdownList, selectItems) => {
    const addSelected = (event, item) => {
      for (const item of dropdownList.children) {
        item.classList.remove('is-selected')
      }

      if (event.target.innerText !== '') {
        item.classList.add('is-selected')

        docSelect.value = event.target.innerText
      }

      selectItems.forEach((item) => {
        if (item.text === event.target.innerText) select.value = item.value
      })

      select && select.dispatchEvent(new Event('change', { bubbles: true }))

      dropdownList.classList.toggle('is-visible')
    }

    arr &&
      arr.forEach((item) => {
        item.addEventListener('click', (event) => {
          addSelected(event, item)
        })

        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            addSelected(e, item)
          }

          if (e.key === 'Escape') {
            if (
              dropdownList &&
              !dropdownList.classList.contains('is-visible')
            ) {
              dropdownList.classList.add('is-visible')
            }
          }
        })
      })
  }

  const renderDropdown = (select, docSelect, dropdown, dropdownList) => {
    const selectItems = []
    const dropdownListItems = []
    let filteredSelectItems = []

    docSelect.onfocus = () => {
      docSelect.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (dropdownList && dropdownList.classList.contains('is-visible')) {
            dropdownList.classList.remove('is-visible')
          }
        }

        if (e.key === 'Escape') {
          if (dropdownList && !dropdownList.classList.contains('is-visible')) {
            dropdownList.classList.add('is-visible')
          }
        }
      })
    }

    docSelect.addEventListener('input', (e) => {
      if (dropdownList && dropdownList.classList.contains('is-visible')) {
        dropdownList.classList.remove('is-visible')
      }

      filteredSelectItems = selectItems.filter(
        (item) =>
          item.text.includes(e.target.value) ||
          item.text.toLowerCase().includes(e.target.value),
      )

      if (filteredSelectItems.length > 0) {
        dropdownList.innerHTML = filteredSelectItems
          .map(
            (item) =>
              `<div class="select-dropdown-content__item focus-clickable w-full" tabindex="0">
                <div class="select-dropdown-content__item-text w-full">
                  ${item.text}
                </div>
              </div>`,
          )
          .join('')
      } else {
        dropdownList.innerHTML = `<div class="select-dropdown-content__item w-full">
                                    <div class="select-dropdown-content__item-text w-full>
                                    
                                    </div>
                                  </div>`
      }

      dropdownListItems.splice(0, dropdownListItems.length)

      for (const item of dropdownList.children) {
        dropdownListItems.push(item)
      }

      if (e.target.value === '') {
        select.value = ''
        select && select.dispatchEvent(new Event('change', { bubbles: true }))
      }

      addListener(
        dropdownListItems,
        select,
        docSelect,
        dropdownList,
        selectItems,
      )
    })

    dropdown &&
      dropdownList &&
      dropdown.addEventListener('click', () => {
        if (dropdownList && dropdownList.classList.contains('is-visible')) {
          dropdownList.classList.remove('is-visible')
        } else {
          dropdownList.classList.add('is-visible')
        }
      })

    if (dropdownList && select) {
      for (const item of select.children) {
        if (item.value !== '') {
          selectItems.push({
            value: item.value,
            text: item.text,
            selected: item.selected,
          })
        }
      }

      dropdownList.innerHTML = selectItems
        .map((item) => {
          if (item.value !== '') {
            return `<div class="select-dropdown-content__item focus-clickable w-full" tabindex="0">
                        <div class="select-dropdown-content__item-text w-full">
                          ${item.text}
                        </div>
                      </div>`
          }
        })
        .join('')

      for (const item of dropdownList.children) {
        dropdownListItems.push(item)
      }

      if (selectItems.length > 0)
        selectItems.forEach((item, index) => {
          if (item.selected && item.value !== '') {
            docSelect.value = item.text

            dropdownList.children[index].classList.add('is-selected')
          }
        })

      addListener(
        dropdownListItems,
        select,
        docSelect,
        dropdownList,
        selectItems,
      )
    }
  }

  selects &&
    selects.forEach((item, index) => {
      renderDropdown(
        item,
        docSelectArr[index],
        dropdowns[index],
        dropdownLists[index],
      )
    })

  resetButton &&
    resetButton.addEventListener('click', () => {
      filterForm && filterForm.reset()

      if (dropdownLists) {
        dropdownLists.forEach((list) => {
          for (const item of list.children) {
            item.classList.remove('is-selected')
          }
          calendarRange.clear()
          calendarSingle.clear()
        })
      }
    })

  document.addEventListener('click', (event) => {
    if (dropdowns && dropdownLists) {
      dropdowns.forEach((dropdown, index) => {
        if (!dropdown.contains(event.target)) {
          dropdownLists[index].classList.add('is-visible')
        }
      })
    }
  })
})
